import React from 'react';
import { theme } from '../Theming/Theming';
import { styled } from 'linaria/react';
import { useSiteContent } from '../Util/useSiteContent';

const ProductUspBoxWrapper = styled('div')`
  width: 100%;
  margin-top: 1rem;
  padding: 1rem 0;
  &.ProductPageUsp {
    border-top: 1px solid ${theme.colors.border};
    img {
      max-width: 90px;
      max-height: 60px;
    }
  }
  &.ProductPageUspBottom {
    background: ${theme.colors.backgroundLight};
    padding: 2rem 0.5rem;
    ul {
      justify-content: space-around;
      flex-direction: row;
      flex-wrap: wrap;
      li {
        margin: 1rem;
      }
    }
    img {
      max-width: 200px;
      max-height: 100px;
    }
  }
  ${theme.below.lg} {
    padding-bottom: 0.5rem;
  }
  .title {
    font-weight: ${theme.weights.bold};
    margin-bottom: 1rem;
  }
  ul {
    display: flex;
    justify-content: center;
    flex-direction: column;
    ${theme.above.lg} {
      flex-direction: row;
      justify-content: space-around;
    }
    li {
      display: flex;
      align-items: center;
      margin: 0 0 1rem;
      ${theme.above.lg} {
        margin: 0 1rem 1rem;
      }
      &,
      p > span {
        font-size: 0.9rem;
        color: #aaa;
      }
      p {
        color: ${theme.colors.font};
      }
      span,
      img {
        display: block;
      }
      svg {
        margin-right: 1.5rem;
      }
    }
  }
`;

const ProductUspBox = ({ name }) => {
  const items = useSiteContent([name]);
  if (items && items.show)
    return (
      <ProductUspBoxWrapper className={name}>{items.html}</ProductUspBoxWrapper>
    );
  return null;
};

export default ProductUspBox;
